import { type ReactElement, type ReactNode, useState } from "react"
import { useLocation } from "react-router-dom"
import { OrderManagementHome } from "src/features/orderManagement";
import { RootState } from "src/app/store";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "src/features/authentication/hooks/userAuth";
import { useDispatch, useSelector } from "react-redux";
import { useIdleTimer } from "react-idle-timer";
import LogoutModal from "src/features/authentication/components/LogoutModal";
import { AppDispatch } from "src/app/store";

export interface OrderManagementProps {
        children?: ReactNode
}

export function OrderManagementPage(props: OrderManagementProps): ReactElement {
        const location = useLocation();
        const history = location.state?.from;
        const { authUser } = useSelector((state: RootState) => state.auth);
        const { dealer } = useSelector((state: RootState) => state.dealer);
        const [showLogoutModal, setShowLogoutModal] = useState(false);
        const dispatch = useDispatch<AppDispatch>();

        const onIdle = () => {
                setShowLogoutModal(false);
                if (showLogoutModal) {
                        dispatch(logoutUser(authUser));
                        dispatch({ type: "RESET" });
                }
        }

        const staySignedIn = () => {
                setShowLogoutModal(false);
                reset();
        }

        const onPrompt = () => {
                setShowLogoutModal(true);
        }

        const { getRemainingTime, reset } = useIdleTimer({
                onIdle,
                onPrompt,
                timeout: 1000 * 60 * 8,
                promptBeforeIdle: 1000 * 60 * 3,
                debounce: 500
        })

        return <>
                <OrderManagementHome dealerId={dealer.Id.toString()} browhistory={history} />
                {showLogoutModal ?
                        <LogoutModal title="Logout Modal" isOpen={showLogoutModal} onClose={staySignedIn} />
                        :
                        <></>
                }
        </>
}
